import z from 'zod'

export const validationSchema = z.object({
  notes: z.string().max(240).optional().nullable(),
  rating: z.number().gte(1).lte(5),
})
